<div
  class="wuc-rack"
  [ngClass]="['wuc-rack--desktop-' + desktop, 'wuc-rack--tablet-' + tablet, 'wuc-rack--mobile-' + columnsMobile]"
  [class.wuc-rack--grid-gap-small]="gridGap === 'small'"
  [class.wuc-rack--grid-gap-medium]="gridGap === 'medium'"
  [class.wuc-rack--grid-gap-large]="gridGap === 'large'"
>
  <ng-content></ng-content>
</div>
